export default __webpack_public_path__ + "dfefdf2116b3f5ce9ee38125c8893af0.png";